
import { cn } from "../lib/utils";

export function Required( { className } ) {

  return (

    <span className={ cn( "text-red pl-0.5", className ) }>

      &#42;

    </span>

  )

}
